import { envVars } from '@constants';

export const buildUrl = (path) => `${envVars.apiV2BaseUrl}/${path}`;

export const stats = {
  json: JSON.stringify(
    {
      data: [
        {
          clicks: 13,
          captured: 7,
          published_true_pay: 0.0,
          pending_true_pay: 0.0,
          rejected_true_pay: 0.0,
          published_conversions: 5,
          pending_conversions: 1,
          rejected_conversions: 1,
          conversion_percentage: 38.46,
          true_pay_epc: 0.14,
          total_true_pay: 100,
          order_total: 23,
          affiliate_id: 2,
          image_creative: {
            id: 223,
            size: '160x600',
          },
          text_creative: {
            id: 223,
            size: 'Feed Creative',
          },
          image_creative_id: null,
          text_creative_id: null,
        },
      ],
      meta: {
        total: {
          clicks: 71,
          impressions: 0,
          captured: 20,
          pending_conversions: 10,
          published_conversions: 5,
          rejected_conversions: 5,
          conversion_percentage: 28.169014084507,
          total_true_pay: 765.0,
          published_true_pay: 226.0,
          pending_true_pay: 539.0,
          rejected_true_pay: 213.0,
          true_pay_epc: 10.3,
          order_total: 23,
        },
        pagination: {
          page: 1,
          per_page: 50,
          total_entries: 10,
        },
        locale: 'en-US',
        currency: 'USD',
        time_zone: '0.0',
      },
    },
    undefined,
    2
  ),
  xml: `<hash>
  <data>
    <stats type="array">
      <stat>
        <clicks type="integer">23</clicks>
        <captured>11</captured>
        <conversions>6</conversions>
        <total-pending-conversions>0</total-pending-conversions>
        <total-rejected-conversions>5</total-rejected-conversions>
        <conversion-percentage>26.0869565217391</conversion-percentage>
        <epc>68.8882608695652</epc>
        <average-true-pay>264.0716</average-true-pay>
        <total-true-pay>1584.43</total-true-pay>
        <affiliate>(1) Rustic Cotton Hat</affiliate>
        <image-creative-id nil="true"/>
        <text-creative-id nil="true"/>
      </stat>
    </stats>
    <stat-total>
      <clicks type="integer">23</clicks>
      <captured>11</captured>
      <conversions>6</conversions>
      <total-pending-conversions>0</total-pending-conversions>
      <total-rejected-conversions>5</total-rejected-conversions>
      <conversion-percentage>26.0869565217391</conversion-percentage>
      <epc>68.8882608695652</epc>
      <average-true-pay>264.0716</average-true-pay>
      <total-true-pay>1584.43</total-true-pay>
    </stat-total>
  </data>
</hash>`,
};

export const conversions = {
  json: JSON.stringify(
    {
      meta: {
        pagination: {
          page: 1,
          per_page: 50,
          total_entries: 82,
        },
        locale: 'en-US',
        currency: 'USD',
        time_zone: '8.0',
        api_key: '7ce289724a5ad8e21c49bea3cfbbabf3',
      },
      data: [
        {
          id: '1655',
          unique_id: '1656',
          recorded_at: '2024-04-28 16:43:31',
          captured_at: '2024-05-07 23:58:31',
          published_at: null,
          updated_at: '2024-04-28 23:48:19',
          offer_id: 80,
          offer_name: 'Rustic Leather',
          converted_at: null,
          offer_variant_id: 159,
          affiliate_id: 2,
          true_pay: 14.3,
          conversions: 1,
          order_number: 'TEST-2-1655',
          order_total: 4000.0,
          subid_1: null,
          subid_2: null,
          subid_3: null,
          subid_4: null,
          subid_5: null,
          adv_uniq_id: null,
          conversion_name: 'Sale',
          step_label: 'Sale',
          step_name: 'sale',
          conversion_type: 'CPS',
          approval: 'Pending',
        },
      ],
    },
    undefined,
    2
  ),
  xml: `<hash>
  <meta>
    <pagination>
      <page type="WillPaginate::PageNumber">1</page>
      <per-page type="integer">50</per-page>
      <total-entries type="integer">11</total-entries>
    </pagination>
    <locale>en-US</locale>
    <currency>TWD</currency>
    <time-zone>-12.0</time-zone>
    <api-key>73968c83b9b1d5e6d040d546660a882b</api-key>
  </meta>
  <transactions type="array">
    <transaction>
      <id>1655</id>
      <unique-id>1656</unique-id>
      <recorded-at>2024-04-28 16:43:31</recorded-at>
      <captured-at>2024-05-07 23:58:31</captured-at>
      <published-at nil="true"/>
      <updated-at>2024-04-28 23:48:19</updated-at>
      <offer-id type="integer">80</offer-id>
      <offer-name>Rustic Leather</offer-name>
      <converted-at nil="true"/>
      <offer-variant-id type="integer">159</offer-variant-id>
      <affiliate-id type="integer">2</affiliate-id>
      <true-pay>14.3</true-pay>
      <conversions type="integer">1</conversions>
      <order-number>TEST-2-1655</order-number>
      <order-total type="float">4000.0</order-total>
      <subid-1 nil="true"/>
      <subid-2 nil="true"/>
      <subid-3 nil="true"/>
      <subid-4 nil="true"/>
      <subid-5 nil="true"/>
      <aff-uniq-id nil="true"/>
      <conversion-name>Sale</conversion-name>
      <step-label>Sale</step-label>
      <step-name>sale</step-name>
      <conversion-type>CPS</conversion-type>
      <approval>Pending</approval>
    </transaction>
    <transaction>...</transaction>
  </transactions>
</hash>`,
};
